type LatLngLike =
  | google.maps.LatLngLiteral
  | {
      lat: number | string
      lng: number | string
    }

const DEFAULT_CENTER: google.maps.LatLngLiteral = {
  lat: -30.0389,
  lng: -51.1845,
}

const isFiniteNumber = (value: number): boolean => Number.isFinite(value)

export const normalizeLatLng = (
  coords: LatLngLike | null | undefined,
  fallback?: google.maps.LatLngLiteral,
): google.maps.LatLngLiteral => {
  if (!coords) {
    return fallback ?? DEFAULT_CENTER
  }

  const lat = Number((coords as LatLngLike).lat)
  const lng = Number((coords as LatLngLike).lng)

  if (!isFiniteNumber(lat) || !isFiniteNumber(lng)) {
    console.warn('Invalid coordinates received', coords)
    return fallback ?? DEFAULT_CENTER
  }

  return { lat, lng }
}

export const defaultCenter = DEFAULT_CENTER
